import Adicionar from './Adicionar';
import Assinar from './Assinar';
import Default from './Default';
import Editar from './Editar';
import Historico from './Historico';
import Relatorios from './Relatorios';

const HoleritesDefault = Default;

export default HoleritesDefault;
export const HoleritesAdicionar = Adicionar;
export const HoleritesEditar = Editar;
export const HoleritesRelatorios = Relatorios;
export const HoleritesHistorico = Historico;
export const HoleritesAssinar = Assinar;
